import settings from "../../../constants/settings";
import useFetchAndTrace from "../fetchWithTrace";
import { useState } from "react";
import { InventoryBinFormValues } from "../../../components/internal/parts/InventoryBinForm";

export default function useUpdateInventoryBin(
  onSuccess: () => void,
  onError: (detail: string) => void,
) {
  const fetchAndTrace = useFetchAndTrace();
  const [loading, setLoading] = useState<boolean>(false);

  const updateBinHandler = async (response: Response) => {
    setLoading(false);
    if (response.ok) {
      onSuccess();
    } else if (response.status === 400) {
      const { detail } = (await response.json()) as { detail: string };
      onError(detail);
    } else {
      throw Error("Failed to update bin");
    }
  };

  const errorHandler = () => {
    setLoading(false);
    onError("Failed to add / update bin");
  };

  const saveBin = (bin: InventoryBinFormValues, newBin: boolean) => {
    setLoading(true);
    void fetchAndTrace(
      `${settings.api_url}/inventory/bins`,
      updateBinHandler,
      errorHandler,
      {
        body: JSON.stringify(bin),
        method: newBin ? "POST" : "PUT",
      },
    );
  };

  const removeJobAssociation = (binBarcode: string) => {
    setLoading(true);
    void fetchAndTrace(
      `${settings.api_url}/inventory/bins/remove-job-association`,
      updateBinHandler,
      errorHandler,
      {
        body: JSON.stringify({
          flashpcb_bin_barcode: binBarcode,
        }),
        method: "PUT",
      },
    );
  };

  return { saveBin, removeJobAssociation, loading };
}
